import { Component } from 'react';
var moment = require('moment');

export default class extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return this.props.date ? moment(this.props.date).format('LT') : moment().format('LT')
    }
}
